export enum Breakpoint {
  sm = 768,
  lg,
}

export const getBreakpointsState = (width: number) =>
  width > Breakpoint.sm ? Breakpoint.lg : Breakpoint.sm;
